export const htmlToText = (html, fallback = "") => {
  if (!html || typeof html !== "string") return fallback;

  const document = new DOMParser().parseFromString(html, "text/html");
  return document.body.textContent?.trim() || fallback;
};
